import hljs from 'highlight.js';

setTimeout(function () {
    document
        .querySelectorAll('pre code')
        .forEach((block) => hljs.highlightElement(block));
}, 1000);